"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _EcommerceStore = _interopRequireDefault(require("settings-ui-sdk/EcommerceV2/EcommerceStore"));

var _EcommerceStoreDetails = _interopRequireDefault(require("settings-ui-sdk/EcommerceV2/EcommerceStoreDetails"));

var _EcommerceStoreStats = _interopRequireDefault(require("./EcommerceStoreStats"));

var _handleActions;

// { stores : { <storeToken> : {Store object} } }
var initialState = new _immutable.Map({
  stores: new _immutable.Map(),
  details: new _EcommerceStoreDetails.default()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchStoresActionTypes.SUCCESS, function (state, action) {
  var storesById = action.payload.data.results.reduce(function (stores, store) {
    return stores.set(store.storeToken, new _EcommerceStore.default(store));
  }, new _immutable.Map());
  return state.set('stores', storesById);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchStoreDetailsActionTypes.SUCCESS, function (state, action) {
  return state.set('details', new _EcommerceStoreDetails.default((0, _extends2.default)({
    storeToken: action.payload.props
  }, action.payload.data)));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchImportDetailsActionTypes.SUCCESS, function (state, action) {
  return state.setIn(['details', 'import'], new _immutable.Map(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchStatsActionTypes.SUCCESS, function (state, action) {
  return state.setIn(['details', 'counts'], new _EcommerceStoreStats.default(action.payload.data));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;